<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">市场调查</div>
      <div class="t-t2box">
        <div class="t-t2">实时倾听客户心声 精准把脉业务短板</div>
      </div>
    </div>

    <!-- 第一部分 -->
    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多场景满意度测评 满足您不同的业务需求</div>
        <br />
        <div class="t2">助您洞察市场的真实情况</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/products/tub1.png" alt="" />
          </div>
          <div class="text1">NPS/综合满意度</div>

          <div class="text2">产品 | 服务 | 品牌 | 金融</div>
          <div class="text3">汽车 | 餐饮 | 教育 | 医疗 | TMT</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/tub2.png" alt="" />
          </div>
          <div class="text1">产品满意度</div>

          <div class="text2">观感 | 易用性 | 质量</div>
          <div class="text3">使用 | 技术 | 价格</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/tub3.png" alt="" />
          </div>
          <div class="text1">服务满意度</div>

          <div class="text2">流程 | 人员 | 设施</div>
          <div class="text3">专业性 | 体验</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/tub4.png" alt="" />
          </div>
          <div class="text1">品牌满意度</div>

          <div class="text2">忠诚度 | 推荐度 | 影响力</div>
          <div class="text3">口碑 | 责任感</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/products/tub5.png" alt="" />
          </div>
          <div class="text1">采购商/经销商满意度</div>

          <div class="text2">信息获取 | 签约流程 | 交付过程</div>
          <div class="text3">销售服务 | 售后服务</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/tub6.png" alt="" />
          </div>
          <div class="text1">员工满意度</div>

          <div class="text2">管理体系 | 企业文化 | 团队合作</div>
          <div class="text3">奖罚机制| 发展机会</div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <!-- 第二部分 -->
    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">一站式全案研究</div>
        <br />
        <div class="t2">研究规划、需求梳理、方案实际</div>
      </div>

      <div class="bintu">
        <img src="@/image/products/bintu.png" alt="" />
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">使用场景</div>
        <br />
        <div class="t2">深度赋能企业调研，助力业务精确决策</div>
      </div>

      <!-- 内容 -->
      <div class="box3">
        <div class="item3">
          <img src="@/image/products/tu1@2x.png" class="img3" alt="" />

          <div class="btoom">
            <img src="@/image/products/diaoyan.png" alt="" />

            <div class="text3">科学多元化评估品牌元素对于消费者购买的影响力， 助力企业优化品牌设计，定制产品规划。</div>
          </div>
        </div>

        <div class="item3">
          <img src="@/image/products/tu2@2x.png" class="img3" alt="" />

          <div class="btoom">
            <img src="@/image/products/diaoyan.png" alt="" />

            <div class="text3">多维立体化的数据分析，直观呈现目前产品的市场规模与地位，助力企业找到差异化定位。</div>
          </div>
        </div>

        <div class="item3">
          <img src="@/image/products/tu3@2x.png" class="img3" alt="" />

          <div class="btoom">
            <img src="@/image/products/diaoyan.png" alt="" />

            <div class="text3">多渠道精准投放问卷，快速获取目前产品的消费市场偏好度，推动企业产品完成转型与升级。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstProduct',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/bj@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}
//第一部分
.row1 {
  height: 870px;

  position: relative;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 370px;
      height: 270px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 90px;
        height: 85px;
        margin: 25px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 250px;
        text-align: center;
        margin: 30px auto 16px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }
      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;

      transition-timing-function: linear;
    }
  }

  .zixun {
    letter-spacing: 1px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 0px auto;
  }
}

.row2 {
  height: 870px;

  position: relative;
  overflow: hidden;

  background-color: #f7f8fb;
  // 标题
  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 85px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .bintu {
    position: absolute;
    left: 50%;
    top: 15%;
    transform: translateX(-50%);

    width: 1030px;
    height: 660px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.row3 {
  height: 870px;

  position: relative;
  overflow: hidden;

  background-color: #fff;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 85px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box3 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 700px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item3 {
      width: 370px;
      height: 650px;

      margin-right: 38px;

      .img3 {
        width: 100%;
        height: 450px;
      }

      .btoom {
        height: 100px;
        margin-top: 30px;
        box-shadow: 1px 1px 5px 3px #efefef;
        padding-left: 15px;
        img {
          margin: 15px 0 15px 0;

          width: 75px;
          height: 16px;
        }

        .text3 {
          font-size: 14px;
          color: #000000;
        }
      }
    }
  }
}
</style>
